import NewsletterCard from '@components/NewsletterScroller/NewsletterCard';
import Scroller from '@components/Scroller';
import type NewsletterCardApi from '@interfaces/NewsletterCardApi';
import type {ScrollerProps} from '@interfaces/Scroller';
import type {ReactElement} from 'react';

interface Props {
    cards: NewsletterCardApi[];
    scrollerProps: ScrollerProps;
    itemClassName: string;
}

export default function NewsletterCardsScroller(props: Props): ReactElement<Props> {
    return (
        <Scroller {...props.scrollerProps}>
            {props.cards.map((card: NewsletterCardApi) => (
                <NewsletterCard {...card} key={card.code} className={props.itemClassName} />
            ))}
        </Scroller>
    );
}
